<nav class="sidebar-nav">
    <ul id="sidebarnav">
        <!-- User Profile-->
        <li class="sidebar-item user-profile" [class.active]="showMenu === 'user'">
            <a class="sidebar-link has-arrow waves-effect waves-dark" href="javascript:void(0)"
                (click)="addExpandClass('user')" aria-expanded="false"><span><img src="assets/images/users/user1.jpg"
                        alt="user" /></span><span class="hide-menu">{{ getCurrentUser()?.firstName || '' }} {{ getCurrentUser()?.lastName || '' }}</span></a>
            <ul aria-expanded="false" class="collapse" [class.in]="showMenu === 'user'">
                <li><a href="/profile" class="sidebar-link p-0">My Profile </a></li>
                @if(isDevUser()) {
                <li><a href="javascript:void()" class="sidebar-link p-0">My Balance</a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Inbox</a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Account Setting</a></li>
                }
                <li><a class="sidebar-link p-0" href="javascript:void(0)" (click)="logout()">Logout</a></li>
            </ul>
        </li>
        <!-- First level menu -->
        @for(sidebarnavItem of sidebarnavItems; track sidebarnavItem) {
        <li class="sidebar-item" role="button" tabindex="0" [class.active]="showMenu === sidebarnavItem.title"
            (click)="sidebarnavItem.submenu.length !== 0 ? '' : handleNotify()"
            (keydown.enter)="sidebarnavItem.submenu.length !== 0 ? '' : handleNotify()"
            (keydown.space)="sidebarnavItem.submenu.length !== 0 ? '' : handleNotify()"
            [routerLinkActive]="sidebarnavItem.submenu.length !== 0 ? '' : 'active'"
            [routerLinkActiveOptions]="{ exact: sidebarnavItem.submenu.length === 0 }">
            @if(sidebarnavItem.extralink === true) {
            <div class="nav-small-cap"><i [ngClass]="[sidebarnavItem.icon]"></i><span
                    class="hide-menu">{{sidebarnavItem.title | translate}}</span></div>
            }

            @if(!sidebarnavItem.extralink) {
            <a class="sidebar-link waves-effect waves-dark"
                [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
                [ngClass]="[sidebarnavItem.class]" (click)="addExpandClass(sidebarnavItem.title)"
                [routerLinkActive]="sidebarnavItem.submenu.length !== 0 ? '' : 'active'"
                [routerLinkActiveOptions]="{ exact: sidebarnavItem.submenu.length === 0 }">
                <!-- <i [ngClass]="[sidebarnavItem.icon]"></i> -->
                <i-feather [name]="sidebarnavItem.icon" [ngClass]="[sidebarnavItem.icon]"></i-feather>
                <span class="hide-menu">{{sidebarnavItem.title | translate}}
                    @if(sidebarnavItem.label !== '') {
                    <span [ngClass]="[sidebarnavItem.labelClass]">{{sidebarnavItem.label | translate}}</span>
                    }

                </span>
            </a>
            }

            <!-- Second level menu -->
            @if(sidebarnavItem.submenu.length > 0) {
            <ul aria-expanded="false" class="collapse first-level"
                [ngClass]="{'in' : showMenu === sidebarnavItem.title }">
                @for(sidebarnavSubItem of sidebarnavItem.submenu; track sidebarnavSubItem) {
                <li class="sidebar-item" role="button" tabindex="0"
                    (click)="sidebarnavSubItem.submenu.length !== 0 ? '' : handleNotify()"
                    (keydown.enter)="sidebarnavSubItem.submenu.length !== 0 ? '' : handleNotify()"
                    (keydown.space)="sidebarnavSubItem.submenu.length !== 0 ? '' : handleNotify()"
                    [class.active]="showSubMenu === sidebarnavSubItem.title"
                    [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'active'">
                    @if(!sidebarnavSubItem.extralink) {
                    <a class="sidebar-link"
                        [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null : [sidebarnavSubItem.path]"
                        [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                        [ngClass]="[sidebarnavSubItem.class]" (click)="addActiveClass(sidebarnavSubItem.title)"
                        [title]="sidebarnavSubItem.title | translate">
                        <i [ngClass]="[sidebarnavSubItem.icon]"></i>
                        <span class="hide-menu">{{sidebarnavSubItem.title | translate}}</span>
                    </a>
                    }

                    <!-- Third level menu -->
                    @if(sidebarnavSubItem.submenu.length > 0) {
                    <ul aria-expanded="false" class="collapse Second-level"
                        [ngClass]="{'in' : showSubMenu === sidebarnavSubItem.title }">
                        @for(sidebarnavSubsubItem of sidebarnavSubItem.submenu; track sidebarnavSubsubItem) {
                        <li class="sidebar-item"
                            [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'active'"
                            [ngClass]="[sidebarnavSubsubItem.class]">
                            @if(!sidebarnavSubsubItem.extralink) {
                            <a class="sidebar-link" [routerLink]="[sidebarnavSubsubItem.path]"
                                [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'router-link-active'">
                                <i [ngClass]="[sidebarnavSubsubItem.icon]"></i>
                                <span class="hide-menu">{{sidebarnavSubsubItem.title | translate}}</span>
                            </a>
                            }

                        </li>
                        }

                    </ul>
                    }

                </li>
                }

            </ul>
            }

        </li>
        }

    </ul>
</nav>
